<section class="encourage" aria-labelledby="encourage-title" data-testid="preapp-encourage">
  <span class="encourage__icon" aria-hidden="true">
    <app-icon name="zap" [size]="28" />
  </span>
  <h2 class="encourage__title" id="encourage-title">Unlock more funding options</h2>
  <p class="encourage__body">
    Bank data alone may be enough for a Kickstart Cash offer. Adding your financial statements may
    unlock a larger amount and a faster decision — and gives you a stronger path to Debtors Finance.
  </p>

  <h3 class="encourage__why">Why add this information?</h3>
  <ul class="encourage__list">
    <li>
      <app-icon name="check-circle" [size]="16" />
      <span>
        <strong>Higher funding limits</strong> — Debtors Finance can be considered alongside
        Kickstart Cash.
      </span>
    </li>
    <li>
      <app-icon name="check-circle" [size]="16" />
      <span>
        <strong>Flexible options</strong> — accept one facility, both, or neither once CapX comes
        back to you.
      </span>
    </li>
    <li>
      <app-icon name="check-circle" [size]="16" />
      <span><strong>No extra cost</strong> — it doesn't change your Kickstart Cash offer.</span>
    </li>
  </ul>

  <p class="encourage__later">
    You can also add this information later, from your dashboard, while CapX is reviewing your
    enquiry.
  </p>

  <div class="encourage__actions">
    <button
      mat-stroked-button
      type="button"
      (click)="uploadFinancials.emit()"
      data-testid="encourage-upload"
    >
      <app-icon name="arrow-left" [size]="18" />
      <span>Upload financials</span>
    </button>
    <button
      mat-flat-button
      color="primary"
      type="button"
      (click)="submitWithout.emit()"
      data-testid="encourage-submit-without"
    >
      <span>Proceed without financials</span>
      <app-icon name="arrow-right" [size]="18" />
    </button>
  </div>
</section>
